import { MyOrderStatus } from 'entities/common/my-ticket/components/my-order-status'
import { MyOrderStatusPayload } from 'entities/common/my-ticket/model/types'

import { MyOrdersSection } from '../..'

import { MyOrderInfoKyrgyzstan } from './components/my-order-info-kyrgyzstan'

interface MyOrderStatusInfoProps {
  title?: string
  color?: string
  background?: string
  statusInfo?: MyOrderStatusPayload
  onClick?: () => void
}

export const MyOrderStatusInfo = ({
  title,
  color,
  background,
  onClick,
  statusInfo,
}: MyOrderStatusInfoProps) => {
  const hasStatusModal = !!statusInfo

  if (
    hasStatusModal &&
    statusInfo.category === MyOrdersSection.kyrgyzstan.key
  ) {
    return (
      <MyOrderInfoKyrgyzstan
        statusInfo={statusInfo}
        title={title}
        color={color}
        background={background}
      />
    )
  }

  return (
    <MyOrderStatus
      title={title}
      color={color}
      background={background}
      showInfoIcon={false}
      onClick={onClick}
    />
  )
}
